<template>
  <div style="margin:0;padding:0;position: relative; top:1.6rem; left:0;">
    <vs-chip v-if="waringStatus(params.value) > 0" class="ag-grid-cell-chip" color="warning">
      <span>期限切れ間近: {{ waringStatus(params.value) }}件</span>
    </vs-chip>
    <vs-chip  v-if="dangerStatus(params.value) > 0" class="ag-grid-cell-chip" color="danger">
      <span>有効期限切れ: {{ dangerStatus(params.value) }}件</span>
    </vs-chip>
  </div>
</template>

<script>
import * as DateUtil from "@/utils/DateUtil.js";

export default {
  name: "CellRendererLicenseStatus",
  computed: {
    waringStatus() {
      return licenses => {
        const expiredList = this.getExpiredList(licenses);
        const count = expiredList.filter(x => x === "WARNING").length;
        return count;        
      };
    },
    dangerStatus() {
      return licenses => {
        const expiredList = this.getExpiredList(licenses);
        const count = expiredList.filter(x => x === "DANGER").length;
        return count;        
      };
    }
  },
  methods: {
    getExpiredList(licenses) {
      if ( licenses && licenses.length > 0 ) {
        const expiredList = licenses.map(license => {
          let expireDate = DateUtil.toMomentObj(license.expiration_date);
          let diffDate = DateUtil.diffDays(expireDate);
          if (diffDate >= 1) {
            return "DANGER"; // "有効期限が切れています";
          } else if (diffDate >= -30 && diffDate <= 0) {
            return "WARNING"; // `期限切れまで残り${-diffDate + 1}日です`;
          } else {
            return null;
          }
        }).filter(x => !!x);
        return expiredList;
      } else {
        return [];
      }
    },
  },
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
    border-radius: 5px;
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 0.15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}
</style>
